export default __webpack_public_path__ + "static/media/img--interiors-8.4d9127e7.jpg";